const downloadBaseURL = process.env.REACT_APP_ROOT_API_MEDIA;

async function downloadFile(downloadLink: string, fileName: string) {
  try {
    const file = await fetch(downloadLink);
    const blobFile = await file.blob();
    const href = window.URL.createObjectURL(blobFile);
    const link = document.createElement("a");
    link.download = fileName;
    link.href = href;
    link.click();
  } catch (error) {
    console.error(error);
  }
}

async function downloadS3bucketFile(path: string, fileName: string) {
  const downloadLink = `${downloadBaseURL}/${path}`;
  await downloadFile(downloadLink, fileName);
}

export const DownloadUtils = {
  downloadS3bucketFile,
  downloadFile,
};
